import React, { Component, useEffect, useState } from "react";
import { Button, TextField, Stack } from "@mui/material";
import axios from "../../features/axiosHelper";

import Dropdown from "@/components/Dropdown/Dropdown";
import MenuBlock from "../../components/MenuBlock/MenuBlock";
import PopUp from "../../components/PopUp/PopUp";

import "./Notifications.css";
const CreateNewProfilePopUp = ({
  onSave,
  openPopUp,
  setOpenPopUp,
  deliveryProfiles,
}) => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const onChangeName = (event) => {
    setName(event.target.value);
  };
  const onClickSave = (event) => {
    var profile = deliveryProfiles.find((x) => x.name == name);

    if (profile == null) {
      onSave(name);
      setOpenPopUp(false);
    } else {
      setError("Name already exists");
    }
  };

  return (
    <div>
      <PopUp
        size={"small"}
        openPopUp={openPopUp}
        setOpenPopUp={setOpenPopUp}
        title={"Create new Delivery Profile"}
      >
        <Stack
          flexDirection={"column"}
          justifyContent={"space-around"}
          style={{ height: "100%" }}
        >
          <div>
            <p>Enter name for new Delivery Profile</p>
            <TextField
              type="text"
              width="100%"
              placeholder="Enter name"
              onChange={onChangeName}
              value={name}
            />
            {error != "" && <p style={{ color: "red" }}>{error}</p>}
          </div>
          <div align="right">
            <Button
              style={{ width: 180 }}
              className="btn-primary"
              onClick={onClickSave}
            >
              Save
            </Button>
          </div>
        </Stack>
      </PopUp>
    </div>
  );
};
const NotificationDevliveryProfile = () => {
  const [deliveryProfiles, setDeliveryProfiles] = useState([]);
  const [notificationGroups, setNotificationGroups] = useState([]);
  const [notificationDeliveryProfileId, setNotificationDeliveryProfileId] =
    useState(null);
  const [name, setName] = useState(null);
  const [errorMailListId, setErrorMailListId] = useState(null);
  const [warnMailListId, setWarnMailListId] = useState(null);
  const [successMailListId, setSuccessMailListId] = useState(null);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [isSaveBtnDisabled, setIsSaveBtnDisabled] = useState(false);

  const getNotificationDeliveryProfiles = () => {
    axios
      .get("/notifications/delivery-profiles")
      .then((response) => {
        const responseData = response.data;
        responseData.push({
          name: "+ Create a New Profile",
          notificationDeliveryProfileId: -1,
        });
        setDeliveryProfiles(responseData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    setNotificationDeliveryProfileId(null);
    setSuccessMailListId(null);
    setWarnMailListId(null);
    setErrorMailListId(null);
  };
  const getNotificationGroups = () => {
    axios
      .get("/notifications/groups")
      .then((response) => {
        const responseData = response.data;
        responseData.push({
          name: "None",
          notificationMailListId: -1,
        });
        setNotificationGroups(responseData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    getNotificationDeliveryProfiles();
    getNotificationGroups();
  }, []);

  const onSelectDeliveryProfile = (event) => {
    let selected = event.target.value;
    setNotificationDeliveryProfileId(selected);

    let profile = deliveryProfiles.find(
      (x) => x.notificationDeliveryProfileId == selected
    );
    setName(profile.label);

    if (selected == -1) {
      //create new Delivery Profile
      setOpenPopUp(true);
    } else {
      //load data from profile - update dropdowns
      setSuccessMailListId(profile.successMailListId ?? -1);
      setWarnMailListId(profile.warnMailListId ?? -1);
      setErrorMailListId(profile.errorMailListId ?? -1);
    }
  };
  const onSaveCreateNewProfile = (name) => {
    deliveryProfiles.push({
      name: name,
      notificationDeliveryProfileId: -2,
    });
    setDeliveryProfiles(deliveryProfiles);
    setNotificationDeliveryProfileId(-2);
    setName(name);
  };
  const onClickSaveProfile = () => {
    setIsSaveBtnDisabled(true);
    axios
      .post("/notifications/delivery-profiles", null, {
        params: {
          notificationDeliveryProfileId: notificationDeliveryProfileId,
          profileName: name,
          errorMailListId: errorMailListId,
          warnMailListId: warnMailListId,
          successMailListId: successMailListId,
        },
      })
      .then((res) => {
        getNotificationDeliveryProfiles();
      })
      .catch((error) => {
        console.error("Error saving option:", error);
      })
      .finally(() => {
        setIsSaveBtnDisabled(false);
      });
  };
  return (
    <MenuBlock title="Setup Notification Delivery Profile" maxHeight={650}>
      <CreateNewProfilePopUp
        openPopUp={openPopUp}
        setOpenPopUp={setOpenPopUp}
        onSave={onSaveCreateNewProfile}
        deliveryProfiles={deliveryProfiles}
      ></CreateNewProfilePopUp>
      <div className="menuBlockContent">
        <Dropdown
          width={320}
          label="Select a Delivery Profile"
          onChange={onSelectDeliveryProfile}
          value={notificationDeliveryProfileId}
          options={deliveryProfiles.map((x) => {
            return { key: x.notificationDeliveryProfileId, label: x.name };
          })}
        ></Dropdown>
        <p>Successful Notifications</p>
        <Dropdown
          width={320}
          label="Select Group"
          onChange={(event) => {
            setSuccessMailListId(event.target.value);
          }}
          value={successMailListId}
          options={notificationGroups.map((x) => {
            return { key: x.notificationMailListId, label: x.name };
          })}
        ></Dropdown>
        <p>Warning Notifications</p>
        <Dropdown
          width={320}
          label="Select Group"
          onChange={(event) => {
            setWarnMailListId(event.target.value);
          }}
          value={warnMailListId}
          options={notificationGroups.map((x) => {
            return { key: x.notificationMailListId, label: x.name };
          })}
        ></Dropdown>
        <p>Error Notifications</p>
        <Dropdown
          width={320}
          label="Select Group"
          onChange={(event) => {
            setErrorMailListId(event.target.value);
          }}
          value={errorMailListId}
          options={notificationGroups.map((x) => {
            return { key: x.notificationMailListId, label: x.name };
          })}
        ></Dropdown>
        <div align="right" style={{ marginTop: "48px" }}>
          <Button
            disabled={isSaveBtnDisabled}
            style={{ width: 180 }}
            className="btn-primary"
            onClick={onClickSaveProfile}
          >
            Save
          </Button>
        </div>
      </div>
    </MenuBlock>
  );
};

export default NotificationDevliveryProfile;
